import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";

export default class PatContinued extends Fragment {
    constructor(continuedBy) {
        super();
        this.continuedBy = continuedBy;

        this.requiredData = [
            {
                name: "continuedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Continued By",
                title: (team) => `Continued By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.continuedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `, ${stringifier.firstInitial(
            this.continuedBy
        )} continued`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            continuedBy: playerReducer(this.continuedBy)
        };
    }
}
